import { NgClass } from '@angular/common';
import { Component, forwardRef, input, signal, viewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validator } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDatepickerToggle } from '@angular/material/datepicker';
import { MatError, MatFormFieldAppearance } from '@angular/material/form-field';
import { MatFormField, MatInput, MatLabel, MatSuffix } from '@angular/material/input';
import { NgxMatDatepickerActions, NgxMatDatepickerApply, NgxMatDatepickerCancel, NgxMatDatepickerInput, NgxMatDatetimepicker } from '@ngxmc/datetime-picker';
import moment, { Moment } from 'moment';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { CUSTOM_DATE_FORMATS_WITH_TIME } from '../../utils/date-utils';

@Component({
  selector: 'app-datetime-picker',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatDatepickerToggle,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    MatSuffix,
    NgClass,
    NgxMatDatepickerActions,
    NgxMatDatepickerApply,
    NgxMatDatepickerCancel,
    NgxMatDatepickerInput,
    NgxMatDatetimepicker,
  ],
  templateUrl: './datetime-picker.component.html',
  styleUrl: './datetime-picker.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatetimePickerComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DatetimePickerComponent),
      multi: true
    },
    provideMomentDateAdapter(CUSTOM_DATE_FORMATS_WITH_TIME),

  ]
})
export class DatetimePickerComponent implements ControlValueAccessor, Validator {
  
  dateFilter = input<(d: Moment) => boolean>(undefined);

  timeFilter = input<(d: Moment) => boolean>(undefined);

  label = input<string>(undefined);

  inputClass = input<{ [key: string]: boolean }>({});
  
  min = input<Moment>(undefined);
  
  max = input<Moment>(undefined);

  name = input<string>(undefined);

  openOnFocus = input<boolean>(false);
  
  placeholder = input<string>(undefined);

  datetimepicker = viewChild(NgxMatDatetimepicker);

  inputAppearance = input<MatFormFieldAppearance>('fill');

  noSubscript = input<boolean>(false);

  required = input<boolean>(undefined);

  error = signal<boolean>(false);

  value?: moment.Moment;
  
  onChange: any = () => {};
  
  onTouched: any = () => {};
  
  

  writeValue(obj: any): void {
    this.value = obj ? moment(obj) : undefined;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(): { [key: string]: any } | null {
    if (!this.value || !this.timeFilter || !this.timeFilter()){
      this.error.set(false);
      return null;
    }

    if (this.timeFilter()(this.value)) {
      this.error.set(false);
      return null;
    }

    this.error.set(true);

    return { invalidHour: true };
  }

  handleChange(date: moment.Moment | null) {
    this.value = date ?? undefined;
    this.onChange(this.value);
    this.onTouched();
  }

  open() {
    this.datetimepicker()?.open();
  }

}
